'use strict';

import lazySizes from 'lazysizes';

// For IE
import 'lazysizes/plugins/respimg/ls.respimg';

lazySizes.init();